import { render, staticRenderFns } from "./home-nav.vue?vue&type=template&id=1012fd02&scoped=true&"
import script from "./home-nav.vue?vue&type=script&lang=js&"
export * from "./home-nav.vue?vue&type=script&lang=js&"
import style0 from "./home-nav.vue?vue&type=style&index=0&id=1012fd02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012fd02",
  null
  
)

export default component.exports